import React, { useState } from 'react';
import axios from 'axios';
import Heading from './heading';
import Social from './social';

export default function Feedback() {
    const [message, changeMessage] = useState(false);
    const [goodMessage, changeGoodMessage] = useState(false);
    const [showForm, changeForm] = useState(true);
    const searchParams = new URLSearchParams(window.location.search);
    const parameterValue = searchParams.get('key1');

    // State variable to store form data
    const [formData, setFormData] = useState({
        userID: parameterValue,
        q1: '50',
        q2: '50',
        q3: '',
    });

    const handleSliderChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };

    function logout() {
        window.location.href = "/register"
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if (formData.q1 !== '' && formData.q3 !== '') {
            // Perform actions with form data, such as submitting to a server
            const sendData = async () => {
                try {
                    await axios.post('https://nvedemo24-backend-server.vercel.app/feedback', formData)
                    .then((res) => {
                        changeGoodMessage(true);
                        changeForm(false);
                    });
                } catch (err) {
                    console.log(err);
                }
            };
            sendData();
        } else {
            changeMessage(true);
        }
    };

    return (
        <>
            <Heading/>
            {message && <h1 className="demo-heading">PLEASE FILL OUT THE FORM</h1>}
            {goodMessage && <h1 className='demo-heading'>THANK YOU FOR COMPLETING THE FORM</h1>}
            {showForm ? (
                <>
                    <h1 className='demo-heading'>How did you like our demo?</h1>
                    <div>
                        <form className='form-container' onSubmit={handleSubmit}>
                            <div className='question-container'>
                                <label className='question' htmlFor="q1">Did you feel that our slogan “Morally Coded, Technically Sound; Securing the World Through Color” was reflected through this technology demo?</label>
                                <input
                                    className='slider'
                                    type="range"
                                    min="1"
                                    max="100"
                                    onChange={handleSliderChange}
                                    name="q1"
                                    value={formData.q1}
                                />
                            </div>
                            <div className='question-container'>
                                <label className='question' htmlFor="q2">How confident would you feel entrusting your most sensitive information with us?</label>
                                <input
                                    className='slider'
                                    type="range"
                                    min="1"
                                    max="100"
                                    onChange={handleSliderChange}
                                    name="q2"
                                    value={formData.q2}
                                />
                            </div>
                            <div className='question-container'>
                                <label className='question' htmlFor="q3">If there was a recommendation you would give Colorantí for its next steps, what would it be?</label> 
                                <input
                                    className='slider'
                                    type="text"
                                    placeholder='ENTER TEXT'
                                    onChange={handleSliderChange}
                                    name="q3"
                                    value={formData.q3}
                                />
                            </div>
                            <button className="login-button" type="submit">Submit</button>
                        </form>
                    </div>
                </>
            ) : (
                <div className='logout-container'>
                    <button className='logout' onClick={logout}>Logout?</button>
                </div>
            )}
            <Social/>
        </>
    );
};
